import type { FC, LabelHTMLAttributes, ReactNode } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Text, type TextProps } from "../Text/Text";
import { labelStyle, labelTextStyle } from "./FormLabel.css";
import { Flex } from "../Flex/Flex";
import type { ChildrenProp } from "../../props";

export type FormLabelProps = Omit<
  LabelHTMLAttributes<HTMLLabelElement>,
  "color"
> &
  ChildrenProp &
  TextProps & {
    leading?: ReactNode;
    trailing?: ReactNode;
  };

/**
 * FormLabel component is a label for form elements.
 */
export const FormLabel: FC<FormLabelProps> = ({
  children,
  variant = "bodyM",
  color,
  leading,
  trailing,
  ellipsis = true,
  className,
  ...props
}) => (
  <Flex gap="xs" align="center" className={mergeClasses(labelStyle, className)}>
    {leading}
    <Text
      as="label"
      className={labelTextStyle}
      variant={variant}
      color={color}
      ellipsis={ellipsis}
      {...props}
    >
      {children}
    </Text>
    {trailing}
  </Flex>
);
